// 기본 색상 정의 (폴백용)
const DEFAULT_COLORS = {
	// base colors
	primary: '#03c765',
	primaryDark: '#00f790', //#e57d1d44',
	primaryOpacity:
		'linear-gradient(0deg,hsla(0,0%,100%,.9),hsla(0,0%,100%,.9)),#00f7ad',
	secondary: '#00c288',
	backgroundColor: '#faf5f5',

	BTN_NORMAL: '#FFFFFF',
	BTN_HOVER: '#00c74c',
	inputBackground: '#484e44',
	borderColor: '#444444',
	HeaderBarBackground: '#221d1d',

	// colors
	black: '#1C1C1C',
	white: '#FFFFFF',
	grayWhite: '#F1F1F1',
	greyWhite: '#E9E9E9',
	lightGray: '#908888',
	lightGray1: '#adb1b8',
	lightGray2: '#EEE',
	lightGray3: '#dbd3d3',
	lightGray4: '#C4C4C4',
	lightGray5: '#7D7E84',
	grey: '#202020',
	grey1: '#202124',
	gray: '#2D3038',
	gray1: '#282C35',
	gray2: '#404347',
	darkRed: '#921515',
	lightRed: '#ff4d4d',
	darkBlue: '#121627 ',
	lightBlue: '#00ADF2',
	darkGreen: '#393cff',
	lightGreen: '#3172fd',
	green: '#24ae64',
	bgGreen: 'rgba(36,174,100,.08)',
	themePurple: '#e54a23',
	loginbgb: 'rgba(0,0,0,0.5)',
	loginbgw: 'rgba(255,255,255,0.5)',
	grad1: '#B5F24E',
	grad2: '#27F0D7',
	gradtext : '#000000',
}

// 브랜드 스타일 타입 정의
interface BrandStyles {
	primary?: string;
	primaryDark?: string;
	secondary?: string;
	BTN_HOVER?: string;
	grad1?: string;
	grad2?: string;
	gradtext?: string;
	[key: string]: any;
}

// 브랜드 스타일 캐싱을 위한 변수
let cachedBrandStyles: BrandStyles | null = null;
let cacheInitialized = false;

// 브랜드 테마에서 색상을 동적으로 가져오는 함수 (캐싱 적용)
const getBrandStyles = (): BrandStyles => {
	if (!cacheInitialized) {
		try {
			const brandTheme = (window as any).BRAND_THEME;
			if (brandTheme?.styles) {
				cachedBrandStyles = brandTheme.styles;
				console.log('브랜드 스타일 초기 로딩 성공:', brandTheme.styles);
			}
		} catch (error) {
			console.error('브랜드 스타일 로딩 실패:', error);
		}
		cacheInitialized = true;
	}
	return cachedBrandStyles || {};
}

// 동적 COLORS 객체 - getter를 사용하여 런타임에 값 결정
export const COLORS = {
	// 동적 브랜드 색상 (런타임에 window.BRAND_THEME에서 읽음)
	get primary() {
		return getBrandStyles().primary || DEFAULT_COLORS.primary;
	},
	get primaryDark() {
		return getBrandStyles().primaryDark || DEFAULT_COLORS.primaryDark;
	},
	get secondary() {
		return getBrandStyles().secondary || DEFAULT_COLORS.secondary;
	},
	get BTN_HOVER() {
		return getBrandStyles().BTN_HOVER || DEFAULT_COLORS.BTN_HOVER;
	},
	get grad1() {
		const styles = getBrandStyles();
		return styles.grad1 || DEFAULT_COLORS.grad1;
	},
	get grad2() {
		const styles = getBrandStyles();
		return styles.grad2 || DEFAULT_COLORS.grad2;
	},
	get gradtext() {
		const styles = getBrandStyles();
		const result = styles.gradtext || DEFAULT_COLORS.gradtext;
		return result;
	},

	// 정적 색상 (변경되지 않는 색상들)
	primaryOpacity: DEFAULT_COLORS.primaryOpacity,
	backgroundColor: DEFAULT_COLORS.backgroundColor,
	BTN_NORMAL: DEFAULT_COLORS.BTN_NORMAL,
	inputBackground: DEFAULT_COLORS.inputBackground,
	borderColor: DEFAULT_COLORS.borderColor,
	HeaderBarBackground: DEFAULT_COLORS.HeaderBarBackground,
	black: DEFAULT_COLORS.black,
	white: DEFAULT_COLORS.white,
	grayWhite: DEFAULT_COLORS.grayWhite,
	greyWhite: DEFAULT_COLORS.greyWhite,
	lightGray: DEFAULT_COLORS.lightGray,
	lightGray1: DEFAULT_COLORS.lightGray1,
	lightGray2: DEFAULT_COLORS.lightGray2,
	lightGray3: DEFAULT_COLORS.lightGray3,
	lightGray4: DEFAULT_COLORS.lightGray4,
	lightGray5: DEFAULT_COLORS.lightGray5,
	grey: DEFAULT_COLORS.grey,
	grey1: DEFAULT_COLORS.grey1,
	gray: DEFAULT_COLORS.gray,
	gray1: DEFAULT_COLORS.gray1,
	gray2: DEFAULT_COLORS.gray2,
	darkRed: DEFAULT_COLORS.darkRed,
	lightRed: DEFAULT_COLORS.lightRed,
	darkBlue: DEFAULT_COLORS.darkBlue,
	lightBlue: DEFAULT_COLORS.lightBlue,
	darkGreen: DEFAULT_COLORS.darkGreen,
	lightGreen: DEFAULT_COLORS.lightGreen,
	green: DEFAULT_COLORS.green,
	bgGreen: DEFAULT_COLORS.bgGreen,
	themePurple: DEFAULT_COLORS.themePurple,
	loginbgb: DEFAULT_COLORS.loginbgb,
	loginbgw: DEFAULT_COLORS.loginbgw,
}

export const SIZES = {
	// base colors
	primary: '13px',
	secondary: '12px',
	h1: '30px',
	h2: '24px',
	h3: '20px',
	h4: '18px',
	h5: '16px',
	h6: '14px',
	h7: '12px',
	h8: '10px',
	body1: '14px',
	body2: '12px',
	body3: '10px',
	body4: '8px',
	body5: '6px',
}

export const FONTS = {
	h1: { fontFamily: 'Spoqa Han Sans Neo, sans-serif', fontSize: SIZES.h1 },
	h2: { fontFamily: 'Spoqa Han Sans Neo, sans-serif', fontSize: SIZES.h2 },
	h3: { fontFamily: 'Spoqa Han Sans Neo, sans-serif', fontSize: SIZES.h3 },
	h4: { fontFamily: 'Spoqa Han Sans Neo, sans-serif', fontSize: SIZES.h4 },
	h5: { fontFamily: 'Spoqa Han Sans Neo, sans-serif', fontSize: SIZES.h5 },
	h6: { fontFamily: 'Spoqa Han Sans Neo, sans-serif', fontSize: SIZES.h6 },
	h7: { fontFamily: 'Spoqa Han Sans Neo, sans-serif', fontSize: SIZES.h7 },
	h8: { fontFamily: 'Spoqa Han Sans Neo, sans-serif', fontSize: SIZES.h8 },
	body1: {
		fontFamily: 'Spoqa Han Sans Neo, sans-serif',
		fontSize: SIZES.body1,
	},
	body2: {
		fontFamily: 'Spoqa Han Sans Neo, sans-serif',
		fontSize: SIZES.body2,
	},
	body3: {
		fontFamily: 'Spoqa Han Sans Neo, sans-serif',
		fontSize: SIZES.body3,
	},
	body4: {
		fontFamily: 'Spoqa Han Sans Neo, sans-serif',
		fontSize: SIZES.body4,
	},
	body5: {
		fontFamily: 'Spoqa Han Sans Neo, sans-serif',
		fontSize: SIZES.body5,
	},
}
